import { render, staticRenderFns } from "./MoveCheckboxV2.vue?vue&type=template&id=21b2afbe&scoped=true&"
import script from "./MoveCheckboxV2.vue?vue&type=script&lang=js&"
export * from "./MoveCheckboxV2.vue?vue&type=script&lang=js&"
import style0 from "./MoveCheckboxV2.vue?vue&type=style&index=0&id=21b2afbe&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b2afbe",
  null
  
)

export default component.exports